import { ibanValidateEU, ibanValidateGe } from '@libs/helpers';

export const validateIban = ibanValidateGe;

export const validateIbanEu = ibanValidateEU;
